import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./leaveorgin.css";
import axios from "axios";
import {
  getOrgId,
  UpdateLeavesettingNew,
  GetDepartment,
  GetRestrictedDateSet,
  GetWorkingType,
  UpdateLeavepolicy,
  GetLeaveSettingAll,
  HEADERS,
} from "../../api";

export default function EditTimeOfpolicy() {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [LeavePolicysetting, setLeavePolicysetting] = useState([]);
  const [RestrictedDate, setRestrictedDate] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [EffectiveDate, setEffectiveDate] = useState([]);
  const [selectedWorkingType, setSelectedWorkingType] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [editedLeaveTypeName, setEditedLeaveTypeName] = useState("");
  const [editedworking, setEditedworking] = useState("");

  const [updatedIndx] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const leavepolicy_id = searchParams.get("leave_policy_id") || "";
  const workingID = searchParams.get("associated_working_day_type") || "";
  const leavepolicy_name = searchParams.get("leave_policy_name") || "";
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const associatedWorkingTypeFromURL = queryParams.get(
    "associated_working_day_type"
  );

  useEffect(() => {
    const fetchWorkingTypes = async () => {
      const OrgID = getOrgId(); // Get Organization ID
      try {
        const response = await axios.post(
          GetWorkingType,
          { org_id: OrgID },
          { headers: HEADERS }
        );
        if (response.data.response_code === "0000") {
          const workingTypes = response.data.data.map((type) => ({
            value: type.working_id,
            label: type.working_name,
          }));
          setOptions(workingTypes);
          if (leavepolicy_id) {
            const associatedWorkingType = response.data.data.find(
              (type) =>
                type.working_id === selectedWorkingType?.value ||
                type.working_id === workingID
            );
            if (associatedWorkingType) {
              setSelectedWorkingType({
                value: associatedWorkingType.working_id,
                label: associatedWorkingType.working_name,
              });
            }
          }
        } else {
          console.error("Failed to fetch working types from the API");
        }
      } catch (error) {
        console.error("Error fetching working types:", error);
      }
    };
    fetchWorkingTypes();
  }, [leavepolicy_id, workingID]);

  useEffect(() => {
    setEditedLeaveTypeName(decodeURIComponent(leavepolicy_name || ""));
  }, [leavepolicy_id, leavepolicy_name]);
  useEffect(() => {
    setEditedLeaveTypeName(decodeURIComponent(leavepolicy_name || ""));
  }, [leavepolicy_id, leavepolicy_name]);

  const handelUpdate = async () => {
    try {
      const updatedPolicyName = editedLeaveTypeName;
      const associatedWorkingType = selectedWorkingType?.value;
      const result = await Swal.fire({
        title: "Update Confirmation",
        text: "Are you sure you want to update?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "grey",
        confirmButtonText: "Update",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });

      if (result.isConfirmed) {
        const payload = {
          leave_policy_id: leavepolicy_id,
          policy_name: updatedPolicyName,
          associated_working_day_type: associatedWorkingType,
        };
        console.log("payload", payload);
        const response = await axios.post(UpdateLeavepolicy, payload, {
          headers: HEADERS,
        });
        if (response.data.response_code === "0000") {
          Swal.fire({
            title: "Updated!",
            text: response.data.response_description,
            icon: "success",
            confirmButtonText: "OK",
            buttonsStyling: false,
            confirmButtonColor: "#2d7d9f",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          });
          navigate("/leave-page/time-off-policy");
        } else {
          Swal.fire({
            title: "Failed!",
            text: response.data.response_description,
            icon: "error",
            confirmButtonText: "OK",
            buttonsStyling: false,
            confirmButtonColor: "#2d7d9f",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error updating leave policy:", error);
      Swal.fire({
        title: "Failed!",
        text: "An unexpected error occurred. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        confirmButtonColor: "#2d7d9f",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
        },
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();
      const leavePolicyId = searchParams.get("leave_policy_id") || "";

      try {
        const requestData = {
          organization_id: OrgID,
          lp_id: leavePolicyId,
        };
        const response = await axios.post(GetLeaveSettingAll, requestData, {
          headers: HEADERS,
        });
        console.log("response---------->>>>>+++++", response.data);
        if (response.data.response_code === "0000") {
          setLeavePolicysetting(response.data.data);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const OrgId = getOrgId();
      try {
        const requestData = {
          organization_id: OrgId,
        };
        const response = await axios.post(GetRestrictedDateSet, requestData, {
          headers: HEADERS,
        });
        console.log("RestrictedDateSet::::::::::::", response.data);

        if (response.data.response_code === "0000") {
          setRestrictedDate(response.data.data);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // get department
  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();
      try {
        const requestData = { org_id: OrgID };
        const response = await axios.post(GetDepartment, requestData, {
          headers: HEADERS,
        });
        if (response.data.response_code === "0000") {
          console.log("Get Department:::::::::::::::::", response.data);
          setDepartment(response.data.data);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const updateRowData = (index, newData) => {
    setRowData((prevData) => {
      const updatedData = [...prevData];
      return updatedData;
    });
    if (!updatedIndx.includes(index)) {
      updatedIndx.push(index);
      console.log(updatedIndx, "updatedIndx>>>>");
    }
    if (
      newData.seelctleaveEnabled === true ||
      newData.seelctleaveEnabled === false
    ) {
      LeavePolicysetting[index].leave_enabled = newData.seelctleaveEnabled;
      if (index) {
      }
    }
    if (newData.setInitialSetToDays) {
      LeavePolicysetting[index].initial_set_to_days =
        newData.setInitialSetToDays;
      console.log(
        LeavePolicysetting[index].initial_set_to_days,
        "setInitialSetToDays"
      );
    }
    if (
      newData.setSelectedRestrictedDate === true ||
      newData.setSelectedRestrictedDate === false
    ) {
      LeavePolicysetting[index].restricted_day_off =
        newData.setSelectedRestrictedDate;
      console.log(
        LeavePolicysetting[index].restricted_day_off,
        "restricted_day_off"
      );
    }
    if (
      newData.setselectedSpecialCase === true ||
      newData.setselectedSpecialCase === false
    ) {
      LeavePolicysetting[index].special_case = newData.setselectedSpecialCase;
      console.log(LeavePolicysetting[index].special_case, "special_case");
    }
    if (newData.setSelectedDepartment) {
      LeavePolicysetting[index].approval_department =
        newData.setSelectedDepartment;
      console.log(
        LeavePolicysetting[index].approval_department,
        "approval_department"
      );
    }
    if (newData.setConsicutivesDays) {
      LeavePolicysetting[index].max_consecutive_days =
        newData.setConsicutivesDays;
      console.log(
        LeavePolicysetting[index].max_consecutive_days,
        "max_consicutive_days"
      );
    }
    if (
      newData.setDescriptionRequired === true ||
      newData.setDescriptionRequired === false
    ) {
      LeavePolicysetting[index].description_required =
        newData.setDescriptionRequired;
      console.log(
        LeavePolicysetting[index].description_required,
        "description_required"
      );
    }
    if (newData.setEffectiveDate) {
      LeavePolicysetting[index].effective_date = newData.setEffectiveDate;
      console.log(LeavePolicysetting[index].effective_date, "effective_date");
    }
    if (newData.setselectedrestrictedSatr) {
      LeavePolicysetting[index].restricted_date =
        newData.setselectedrestrictedSatr;
      console.log(LeavePolicysetting[index].restricted_date, "restricted_date");
    }
  };
  const handleCheckboxChange = (index, e) => {
    console.log("Checkbox changed:", e.target.checked);
    updateRowData(index, { seelctleaveEnabled: e.target.checked });
  };
  const handleInitialSetDays = (index, e) => {
    const value = e.target.value;

    const numericValue = value.replace(/\D/g, "");
    updateRowData(index, { setInitialSetToDays: numericValue });
  };

  const handleselectResetDays = (index, e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, "");
    updateRowData(index, { setselectResetDays: numericValue });
  };
  const handleRestrictedDate = (index, e) => {
    updateRowData(index, { setSelectedRestrictedDate: e.target.checked });
  };

  const handleSelectSpecialCase = (index, e) => {
    updateRowData(index, { setselectedSpecialCase: e.target.checked });
  };
  const handleSelectDepartment = (index, e) => {
    updateRowData(index, { setSelectedDepartment: e.target.value });

    console.log("e.target.value", e.target.value);
  };

  const handleConsicutiveDays = (index, e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, "");
    updateRowData(index, { setConsicutivesDays: numericValue });
  };
  const handleEffectiveDate = (index, e) => {
    const value = e.target.value;
    updateRowData(index, { setEffectiveDate: e.target.value });
  };

  const handleDescriptionRequired = (index, e) => {
    console.log("DescriptionRequird::::::::::::", e.target.checked);
    updateRowData(index, { setDescriptionRequired: e.target.checked });
  };

  const handleRestrictedDateSet = (index, e) => {
    updateRowData(index, { setselectedrestrictedSatr: e.target.value });
  };

  const tableData = LeavePolicysetting.map((leaveType, index) => ({
    rowProps: {
      style: {
        backgroundColor: selectedRowIndex === index ? "#f0f0f0" : "transparent",
        cursor: "pointer",
      },
    },
    leave_enabled: (
      <div className="" style={{ marginLeft: "20px" }}>
        <input
          type="checkbox"
          className="check-box"
          id={`leaveEnabled${index}`}
          checked={leaveType.leave_enabled}
          onChange={(e) => handleCheckboxChange(index, e)}
        />
      </div>
    ),
    leave_type_name: leaveType.leave_type_name,
    leave_setting_id: leaveType.leave_setting_id,
    initial_set_to_days: (
      <div className="input-table">
        <input
          className="form-control"
          style={{
            height: 30,
            paddingTop: 3,
            paddingBottom: 3,
            background: "none",
            width: "100%",
            borderRadius: 5,
            paddingLeft: 10,
            borderColor: "#7a7a7a",
          }}
          type="number"
          value={
            leaveType.initial_set_to_days !== null &&
            leaveType.initial_set_to_days !== undefined &&
            leaveType.initial_set_to_days !== 0
              ? leaveType.initial_set_to_days
              : ""
          }
          onChange={(e) => handleInitialSetDays(index, e)}
          min="0"
          placeholder="Set no. of days"
        />
      </div>
    ),
    reset_days: (
      <div className="input-table">
        <input
          className="form-control"
          type="number"
          style={{ maxHeight: 30, background: "none" }}
          value={leaveType.reset_days}
          onChange={(e) => handleselectResetDays(index, e)}
          min="0"
        />
      </div>
    ),
    restricted_day_off: (
      <div style={{ marginLeft: "20px" }}>
        <input
          className="check-box"
          type="checkbox"
          id="selectedRestrictedDate"
          checked={leaveType.restricted_day_off}
          onChange={(e) => handleRestrictedDate(index, e)}
        />
      </div>
    ),

    special_case: (
      <div style={{ marginLeft: "20px" }}>
        <input
          className="check-box"
          type="checkbox"
          id="selectedSpecialCase"
          checked={leaveType.special_case}
          onChange={(e) => handleSelectSpecialCase(index, e)}
        ></input>
      </div>
    ),
    approval_department: (
      <div>
        <select
          style={{
            height: 30,
            paddingTop: 3,
            paddingBottom: 3,
            background: "none",
            width: "100%",
            borderRadius: 5,
            paddingLeft: 10,
            borderColor: "#7a7a7a",
          }}
          value={leaveType.approval_department || ""}
          onChange={(e) => handleSelectDepartment(index, e)}
        >
          <option value="" disabled hidden>
            Select Department
          </option>
          {Department.map((department) => (
            <option key={department.dept_id} value={department.dept_id}>
              {department.dept_name}
            </option>
          ))}
        </select>
      </div>
    ),
    effective_date: (
      <div>
        <input
          type="date"
          className="form-control"
          style={{
            height: 30,
            paddingTop: 3,
            paddingBottom: 3,
            background: "none",
            width: "100%",
            borderRadius: 5,
            paddingLeft: 10,
            borderColor: "#7a7a7a",
          }}
          value={leaveType.effective_date}
          onChange={(e) => handleEffectiveDate(index, e)}
        />
      </div>
    ),

    max_consecutive_days: (
      <div className="input-table" style={{ width: "250px" }}>
        <input
          className="form-control"
          type="number"
          style={{
            height: 30,
            paddingTop: 3,
            paddingBottom: 3,
            background: "none",
            width: "100%",
            borderRadius: 5,
            paddingLeft: 10,
            borderColor: "#7a7a7a",
          }}
          value={
            leaveType.max_consecutive_days === null ||
            leaveType.max_consecutive_days === undefined ||
            leaveType.max_consecutive_days === 0
              ? ""
              : leaveType.max_consecutive_days
          }
          onChange={(e) => handleConsicutiveDays(index, e)}
          min="0"
          placeholder="Set no. of days"
        />
      </div>
    ),
    description_required: (
      <div style={{ marginLeft: "20px", width: "190px" }}>
        <input
          className="check-box"
          type="checkbox"
          id="DescriptionRequired"
          checked={leaveType.description_required}
          onChange={(e) => handleDescriptionRequired(index, e)}
        />
      </div>
    ),

    restricted_date: (
      <div>
        <select
          style={{ display: "none" }}
          value={RestrictedDate[1]?.set_id}
          onChange={(e) => handleRestrictedDateSet(index, e)}
        >
          {RestrictedDate.map((data) => (
            <option key={data.set_id} value={data.set_id}>
              {data.organization_id}
            </option>
          ))}
        </select>
      </div>
    ),
  }));

  const tableColumns = [
    {
      accessorKey: "leave_enabled",
      header: "Enable/Disable",
    },
    {
      accessorKey: "leave_type_name",
      header: "Leave Type",
    },
    {
      accessorKey: "initial_set_to_days",
      header: "Intitial Set Days",
    },
    {
      accessorKey: "restricted_day_off",
      header: "Restricted Day Off",
    },
    {
      accessorKey: "special_case",
      header: "Special Case",
    },
    {
      accessorKey: "approval_department",
      header: "Approval Department",
    },
    {
      accessorKey: "effective_date",
      header: "Effective Date",
    },
    {
      accessorKey: "max_consecutive_days",
      header: "Maximim Consecutive Days",
    },
    {
      accessorKey: "description_required",
      header: "Description Required",
    },
  ];

  const handleCancel = () => {
    navigate("/leave-page/time-off-policy");
  };
  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };
  const Addsetting = async () => {
    if (!LeavePolicysetting || LeavePolicysetting.length === 0) {
      console.error("LeavePolicysetting is empty or undefined");
      return;
    }
    const sortedEdidtLeavePolicyData = updatedIndx.map(
      (index) => LeavePolicysetting[index]
    );
    if (sortedEdidtLeavePolicyData.length > 0) {
      const apiData = sortedEdidtLeavePolicyData
        .filter((row) => row !== undefined)
        .map((row) => ({
          leave_policy_id: leavepolicy_id,
          leave_enabled: row.leave_enabled,
          leave_type: row.leave_type,
          effective_date: row.effective_date,
          initial_set_to_days: parseInt(row.initial_set_to_days, 10),
          earn_days: parseInt(row.earn_days, 10),
          restricted_day_off: row.restricted_day_off,
          special_case: row.special_case,
          approval_department: row.approval_department,
          max_consicutive_days: parseInt(row.max_consecutive_days, 10),
          description_required: row.description_required,
          restricted_date: RestrictedDate[0]?.set_id || "",
        }));
      if (
        !apiData.every(
          (item) =>
            item.leave_policy_id &&
            typeof item.leave_enabled === "boolean" &&
            item.leave_type &&
            item.effective_date &&
            !isNaN(item.initial_set_to_days) &&
            typeof item.restricted_day_off === "boolean" &&
            typeof item.special_case === "boolean" &&
            item.approval_department &&
            !isNaN(item.max_consicutive_days) &&
            typeof item.description_required === "boolean" &&
            item.restricted_date
        )
      ) {
        console.log("adsfads", apiData);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Invalid data detected. Please check your inputs.",
          confirmButtonText: "OK",
          confirmButtonColor: "#2d7d9f",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
          },
        });

        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update the leave settings?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        cancelButtonColor: "grey",
        confirmButtonText: "Update",
        confirmButtonColor: "#2d7d9f",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(UpdateLeavesettingNew, apiData, {
              headers: {
                ...HEADERS,
                "Content-Type": "application/json",
              },
            });
            if (response.data.response_code === "0000") {
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: response.data.response_description,
                confirmButtonText: "OK",
                confirmButtonColor: "#2d7d9f",
                customClass: {
                  confirmButton: "swal-custom-confirm-btn",
                },
              }).then(() => {
                window.location.reload(true);
              });
            } else {
              console.error("API Error:", response.data);
              Swal.fire({
                icon: "error",
                title: "Error!",
                text:
                  response.data.response_description ||
                  "An error occurred while updating leave settings.",
                confirmButtonText: "OK",
                confirmButtonColor: "#2d7d9f",
                customClass: {
                  confirmButton: "swal-custom-confirm-btn",
                },
              });
            }
          } catch (error) {
            console.error(
              "Request failed:",
              error.response?.data || error.message
            );
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: "Failed to update leave settings. Please try again.",
              confirmButtonText: "OK",
              confirmButtonColor: "#2d7d9f",
              customClass: {
                confirmButton: "swal-custom-confirm-btn",
              },
            });
          }
        } else {
          console.log("Update canceled by the user.");
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "No changes detected to update leave settings.",
        confirmButtonText: "OK",
        confirmButtonColor: "#2d7d9f",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
        },
      });
    }
  };
  return (
    <div className="p-2">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link className="previou-link text-decoration-none" to="/leave-page">
            Leave Setting
          </Link>
          <span>/</span>
          <Link
            className="previou-link text-decoration-none"
            to="/leave-page/time-off-policy"
          >
            Leave Policy
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">
            Edit Leave Policy
          </span>
        </span>
      </div>
      <span className="title ">Edit Leave Policy</span>
      <div className="border rounded mt-2">
        <div className=" row d-flex flex-row p-3">
          <div className="form-group  col-md-5">
            <label>Policy Name</label>
            <input
              type="text"
              className="form-control mt-1"
              required
              value={editedLeaveTypeName}
              onChange={(e) => setEditedLeaveTypeName(e.target.value)}
            />
          </div>
          <div className="col-md-5">
            <label>Associated Working Type</label>
            <select
              className="form-select mt-1"
              required
              value={selectedWorkingType?.value || ""}
              onChange={(event) => {
                const selectedOption = options.find(
                  (option) => option.value === event.target.value
                );
                setSelectedWorkingType(selectedOption);
              }}
            >
              <option value="" disabled>
                Select associated working day type
              </option>
              {options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex justify-content-end align-items-center mt-3 col-md-2">
            <button
              className="button add-button justify-content-center"
              style={{ width: "100%" }}
              onClick={handelUpdate}
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <div className=" mt-3 border rounded">
        <div className="tab ">
          <MantineReactTable
            columns={tableColumns}
            enablePagination={false}
            enableColumnFilters={true}
            enableSorting={true}
            enableColumnOrdering={true}
            enableGlobalFilter={true}
            enableRowSelection={false}
            enableFullScreenToggle={false}
            data={paginatedData.map((row) => ({ ...row, ...row.rowProps }))}
            mantineTableBodyCellProps={{
              style: {
                backgroundColor: "#C8E3EC60",
                color: "#505050",
                border: "0.5px solid #fff",
                padding: "10px",
              },
            }}
            mantineTableHeadCellProps={{
              style: {
                backgroundColor: "#2d7d9f",
                fontSize: "14px",
                fontWeight: 500,
                color: "#fff",
                border: "1px solid #fff",
              },
            }}
            mantineTableBodyRowProps={(row) => ({
              style: {
                backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
              },
            })}
          />
          <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px" }}>Items per page:</span>
              <select
                className="form-select"
                style={{ width: "110px" }}
                value={pageSize}
                onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
              >
                <option value={5}>5 rows</option>
                <option value={10}>10 rows</option>
                <option value={20}>20 rows</option>
                <option value={50}>50 rows</option>
                <option value={100}>100 rows</option>
              </select>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <span style={{ fontSize: "14px" }}>
                {totalRows === 0
                  ? "Showing 0 to 0 of 0 entries"
                  : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
              </span>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-3">
              <button
                className="previous-button"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
              >
                Previous
              </button>
              <button
                className="add-button text-center justify-content-center"
                style={{ width: "100px" }}
                onClick={() => handlePageChange(page + 1)}
                disabled={(page + 1) * pageSize >= tableData.length}
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <div
          className="d-flex justify-content-end gap-3 mt-4 mb-4 "
          style={{ marginRight: "20px" }}
        >
          <button type="button" className="button " onClick={handleCancel}>
            Cancel
          </button>
          <button className="button-outline" onClick={Addsetting}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}
